import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { deleteGeneratedDocumentByName, downloadGeneratedDocument } from '../../../services/fileUploadService.js';
import { Context } from '../../../store/Store.js';
import { ForgeCircularProgress, ForgeIconButton, ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import { messageManager } from '../../System/messageManager/messageManager.js';
import './GeneratedDocumentsMenuItems.scss';
import { getFileName, getFormattedDate } from './documentsHelpers.js';
import { REDUCER_ACTION_TYPES } from '../../../store/Reducer.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';

const MenuItemReady = ({ document }) => {
  const [state, dispatch] = useContext(Context);
  const [loading, setLoading] = useState(false);
  const { nameConventions } = useNameConventions();

  const handleDownload = async () => {
    dispatch({ type: REDUCER_ACTION_TYPES.DOWNLOAD, payload: true });
    const downloadLink = (await downloadGeneratedDocument(document.documentName)).data;
    const a = window.document.createElement('a');
    a.href = downloadLink;
    a.download = '';
    window.document.body.appendChild(a);
    a.click();
    a.remove();
    dispatch( { type: REDUCER_ACTION_TYPES.DOWNLOAD, payload: false });
  };

  const handleDelete = async (documentName) => {
    setLoading(true);

    const response = await deleteGeneratedDocumentByName(documentName);
    if (response.status === 200) {
      const filteredDocuments = state.generatedDocuments.filter((document) => document.documentName !== documentName);
      dispatch({ type: REDUCER_ACTION_TYPES.SET_GENERATED_DOCUMENTS, payload: filteredDocuments });
    }
    setLoading(false);
  };

  return (
    <li className="menuItem">
      <div className="name-and-date-container">
        <ForgeIcon external externalType="all" className="opacity54" name={getFileName(document.documentName)} />
        <div>
          <p className="noMargin opacity87">{document.documentName}</p>
          <p className="noMargin forge-typography--body2 opacity54">
            <span className={`${state.theme}`}>{messageManager(nameConventions).DOCUMENT_GENERATOR.DATE_GENERATED} </span>
            {getFormattedDate(document.generationDate)}
          </p>
        </div>
      </div>
      <div className="buttonsContainer">
        <ForgeIconButton id={`generator_delete_icon_${document.id}`} aria-label="Download file" onClick={() => handleDelete(document.documentName)} className="reports_icon_button" >
          {loading ? <ForgeCircularProgress /> : <ForgeIcon external externalType="all" className="opacity54" name="delete" />}
          <ForgeTooltip anchor={`generator_delete_icon_${document.id}`} position="bottom">{'Delete file'}</ForgeTooltip>
        </ForgeIconButton>

        <ForgeIconButton id={`generator_download_icon_${document.id}`} aria-label="Download file" onClick={handleDownload} className="reports_icon_button" >
          <ForgeIcon external externalType="all" className="opacity54" name="file_download" />
          <ForgeTooltip anchor={`generator_download_icon_${document.id}`} position="bottom">{'Download file'}</ForgeTooltip>
        </ForgeIconButton>
      </div>
    </li>
  );
};

MenuItemReady.propTypes = {
  document: PropTypes.object,
};

export default MenuItemReady;
